import * as React from "react";
import type { SVGProps } from "react";
const SvgVelgFilm = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 47" {...props}>
    <path
      d="m871.212 1051.01.145-1.93-4.4.43-3.948-40.96 26.653-2.55.5 5.17 10.851.81-3.1 41.03Z"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-863 -1006)"
    />
  </svg>
);
export default SvgVelgFilm;
